import { Link } from "react-router-dom";
import type { AssigneeRow } from "../../../queries/reports";
import { routes } from "../../../navigation/routes/routes";
import { DashCard } from "./DashCard";
import { Legend, StackedBar } from "./StackedBar";
import {
  STATUS_COLOR, STATUS_LABEL, STATUS_ORDER, buildSegments, formatHours, sumCounts,
} from "./format";
import styles from "./dash.module.css";

interface Props {
  rows?: AssigneeRow[];
  rangeLabel: string;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
}

export const AssigneeSection = ({ rows, rangeLabel, loading, error, onRetry }: Props) => {
  const list = rows || [];
  const max = Math.max(0, ...list.map((r) => sumCounts(r.tasksByStatus)));
  return (
    <DashCard
      title="Projects by assignee"
      helper={`Who is on which project, their task load by status, open tickets and time logged (${rangeLabel}).`}
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={list.length === 0}
      emptyTitle="No assignees yet"
      emptyText="Assign people to projects to see their workload."
    >
      <Legend items={STATUS_ORDER.map((s) => ({ key: s, label: STATUS_LABEL[s], color: STATUS_COLOR[s] }))} />
      <ul className={styles.plainList}>
        {list.map((r) => {
          const segs = buildSegments(r.tasksByStatus, STATUS_ORDER, STATUS_LABEL, STATUS_COLOR);
          return (
            <li key={r.userId} className={styles.person}>
              <div className={styles.personHead}>
                <span className={styles.personName}>{r.name}</span>
                <span className={styles.personRole}>{r.role === "manager" ? "Manager" : "Agent"}</span>
              </div>
              <div className={styles.chips}>
                {r.projects.length === 0 && <span className={styles.muted}>No projects</span>}
                {r.projects.map((p) => (
                  <Link key={p.projectId} className={styles.chip} to={routes.projectBoard.replace(":id", p.projectId)}>
                    {p.name}
                  </Link>
                ))}
              </div>
              <StackedBar segments={segs} max={max} label={`${r.name} tasks by status`} />
              <dl className={styles.facts}>
                <div><dt>Open tasks</dt><dd className="osi-num">{r.openTasks}</dd></div>
                <div><dt>Open tickets</dt><dd className="osi-num">{r.openTickets}</dd></div>
                <div><dt>Logged</dt><dd className="osi-num">{formatHours(r.loggedMinutes)}</dd></div>
              </dl>
            </li>
          );
        })}
      </ul>
    </DashCard>
  );
};
